export default __webpack_public_path__ + "static/media/ilus3.ed71c5a1.jpeg";